import { MapProps } from 'react-map-gl'
import { FitBounds } from './types'
export const DEFAULT_LATITUDE = 37.78
export const DEFAULT_LONGITUDE = -122.45
export const DEFAULT_CENTER: [number, number] = [
  DEFAULT_LONGITUDE,
  DEFAULT_LATITUDE
]
export const DEFAULT_ZOOM: number = 12
// Max zoom to apply when applying fitToBounds (Ex. make sure remote point isn't too zoomed in)
export const MAX_BOUNDING_ZOOM: number = 14
export const DEFAULT_BOUNDS: FitBounds = [
  [-180.0, -90.0],
  [180.0, 90.0]
]

export enum MapStyles {
  Dark = 'mapbox://styles/mapbox/dark-v11',
  Street = 'mapbox://styles/mapbox/streets-v9',
  Street12 = 'mapbox://styles/mapbox/streets-v12',
  CommutifiGreyScale = 'mapbox://styles/commutifi/cm02lfsrn00kz01qr7go7dyoj',
  CommutifiTransitWalkCycling = 'mapbox://styles/commutifi/cm4u2zpda007m01s7avtp6z5l',
  CommutifiTransitWalkCyclingDark = 'mapbox://styles/commutifi/cm4u7vcew009601s79jur55jd'
}

export const defaultFitBoundsOptions: NonNullable<
  MapProps['initialViewState']
> = {
  // Care when changing this value as the smaller maps on will throw errors
  // https://github.com/mapbox/mapbox-gl-js/issues/4344
  padding: { bottom: 25, left: 25, right: 25, top: 25 }
}
